"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _creditCard = _interopRequireDefault(require("@atlaskit/icon/core/credit-card"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CreditcardIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M5.013 17h14v-6h-14zm0-8h14V7h-14zM19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2"/><path d="M7.013 15h2v-2h-2z"/></g></svg>`
}, props, {
  newIcon: _creditCard.default
}));
CreditcardIcon.displayName = 'CreditcardIcon';
var _default = exports.default = CreditcardIcon;